/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { creditCard } from "../assets/credit-card";
import { Icon, type IconBaseProps } from "../icon";

export const IconCreditCard = (props: IconBaseProps) => <Icon {...props} svg={creditCard} />;

IconCreditCard.displayName = "IconCreditCard";
